export type BuildPattern = 'one_day' | 'deploy_pickup' | 'deploy_service_pickup'

export type ServiceCadence = {
    weekdays: number[]
    everyNWeeks: 1
}

export type BuildOutRequirement = {
    kind: 'worker' | 'equipment'
    typeId?: string | null
    workerTypeId?: string | null
    rentalAssetTypeId?: string | null
    qty: number
}

export type ServiceTemplateRequirement = {
    id: string
    kind: 'worker' | 'equipment'
    typeId: string
    qty: number
}

export type BuildOutScheduling = {
    pattern: BuildPattern
    startDate: Date
    endDate: Date
    /** Service visit times, and the fallback for any stage without its own times. */
    startTime?: string | null
    endTime?: string | null
    cadence: ServiceCadence
    serviceTemplate: ServiceTemplateRequirement[]
    serviceTypeId: string | null
    serviceNotes: string
    deployNotes: string
    pickupNotes: string
    /** Stage job names, each set once and reused by every job of that stage. */
    deployJobName?: string
    serviceJobName?: string
    pickupJobName?: string
    deployStartTime?: string | null
    deployEndTime?: string | null
    pickupStartTime?: string | null
    pickupEndTime?: string | null
    skippedServiceDates: string[]
    markJobsReadyForDispatch?: boolean
    /** One-day pattern running every day from startDate to endDate. */
    severalDays?: boolean
    pickupDateTbc?: boolean
    /** Generate service visits only, without deploy and pickup jobs. */
    visitsOnly?: boolean
}

export type GeneratedRequirement = {
    kind: 'worker' | 'equipment'
    typeId: string
    qty: number
}

export type GeneratedJobStage = 'deploy' | 'service' | 'pickup'
export type GeneratedJobStatus = 'active' | 'planned' | 'cancelled'

export type GeneratedJob = {
    id: string
    stage: GeneratedJobStage
    date: Date
    label: string
    endDate?: Date
    requirements: GeneratedRequirement[]
    visitIndex?: number
    skipped?: boolean
}

export const BUILD_REQUIREMENT_KIND_LABELS: Record<BuildOutRequirement['kind'], string> = {
    worker: 'Workers',
    equipment: 'Equipment',
}
